import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  verifyPhoneNumber: 'Verify Phone Number ',
  verify: 'Verify  ',
  updatePhoneNumber: 'Update Phone Number',
  enterOtp: 'Enter the OTP that has been sent to phone number',
  forUpdatePhoneNumber: 'For updating phone number, ',
  enterUpdateNumberOtp:
    'Enter the OTP that has been sent your new phone number',
  phoneNotChanged:
    ' Phone number is the same, Please modify the number to continue.',
  invalidOtp: 'Invalid Otp',
  emailPlaceholder: 'Enter your email',
  logoutFromAllDevices: 'Logout from all devices',
  logoutFromAllDevicesDescription:
    'You will be logged out from all devices, including this one.',
  logoutFromAllDevicesModalDescription:
    'Are you sure you want to logout from all devices?',
  getOut: 'Logout',
});
